import { FC } from 'react';

interface FastForwardIconProps {
  width?: number;
  height?: number;
  color?: string;
}

const FastForwardIcon: FC<FastForwardIconProps> = ({ width = 16, height = 16, color = 'white' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16" fill="none">
      <g id="fast-forward">
        <g id="Icon">
          <path
            d="M8.66659 10.9581C8.66659 11.7114 8.66659 12.0881 8.81876 12.2728C8.95097 12.4332 9.15045 12.5228 9.35819 12.515C9.59731 12.5061 9.87884 12.2558 10.4419 11.7553L13.7697 8.79729C14.0799 8.52157 14.235 8.3837 14.2921 8.22091C14.3423 8.07795 14.3423 7.92216 14.2921 7.7792C14.235 7.61641 14.0799 7.47855 13.7697 7.20282L10.4419 4.24479C9.87884 3.74429 9.59731 3.49404 9.35819 3.48509C9.15045 3.47731 8.95097 3.56689 8.81876 3.72732C8.66659 3.91199 8.66659 4.28867 8.66659 5.04202V10.9581Z"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1.33325 10.9581C1.33325 11.7114 1.33325 12.0881 1.48543 12.2728C1.61763 12.4332 1.81711 12.5228 2.02485 12.515C2.26398 12.5061 2.54551 12.2558 3.10857 11.7553L6.43636 8.79729C6.74655 8.52157 6.90165 8.3837 6.95881 8.22091C7.009 8.07795 7.009 7.92216 6.95881 7.7792C6.90165 7.61641 6.74655 7.47855 6.43636 7.20282L3.10857 4.24479C2.54551 3.74429 2.26398 3.49404 2.02485 3.48509C1.81711 3.47731 1.61763 3.56689 1.48543 3.72732C1.33325 3.91199 1.33325 4.28867 1.33325 5.04202V10.9581Z"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </svg>
  );
};

export default FastForwardIcon;
